// extracted by mini-css-extract-plugin
module.exports = {"glass":"LiquidGlass_glass__3koLG","definitions":"LiquidGlass_definitions__N518C","transmission":"LiquidGlass_transmission__t0LsA"};